"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.Div = exports.Span = exports.P = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme/Theme.spacing");

var _Theme2 = require("../../Theme/Theme.variables");

var _Theme3 = require("../../Theme/Theme.media");

var _Theme4 = require("../../Theme/Theme.display");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n      font-style: italic;\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  line-height: ", ";\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  letter-spacing: ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["font-size: ", "px;"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["font-size: ", "px;"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["font-size: ", "px;"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["font-size: ", "px;"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      font-weight: ", ";\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          text-transform: ", ";\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          text-transform: ", ";\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      text-align: center;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n\n  /* color */\n  ", ";\n\n  ", ";\n\n  /* color */\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var generic = (0, _styledComponents.css)(_templateObject(), function (props) {
  return props.textColor && (0, _styledComponents.css)(_templateObject2(), (0, _Theme2.variables)(props)[props.textColor]);
}, function (props) {
  return props.center && (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.textTransform ? (0, _styledComponents.css)(_templateObject4(), props.textTransform) : (0, _styledComponents.css)(_templateObject5(), function (props) {
    return props.headline ? (0, _Theme2.variables)(props).fontHeadlineTextTransform : (0, _Theme2.variables)(props).fontHeaderTextTransform;
  });
});
var font = (0, _styledComponents.css)(_templateObject6(), function (props) {
  return props.headline ? (0, _Theme2.variables)(props).fontHeadline : (0, _Theme2.variables)(props).fontHeader;
}, function (props) {
  return (0, _Theme2.variables)(props).fontWeight;
}, function (props) {
  return props.headline && (0, _styledComponents.css)(_templateObject7(), (0, _Theme2.variables)(props).fontHeadlineWeight);
});
var sizing = (0, _styledComponents.css)(_templateObject8(), function (props) {
  return (0, _Theme2.variables)(props).headerSizes.default[props.size] * (props.headline ? (0, _Theme2.variables)(props).headlineModifier : 1);
}, function (props) {
  return _Theme3.media.sm(_templateObject9(), (0, _Theme2.variables)(props).headerSizes.sm[props.size] * (props.headline ? (0, _Theme2.variables)(props).headlineModifier : 1));
}, function (props) {
  return _Theme3.media.md(_templateObject10(), (0, _Theme2.variables)(props).headerSizes.md[props.size] * (props.headline ? (0, _Theme2.variables)(props).headlineModifier : 1));
}, function (props) {
  return _Theme3.media.lg(_templateObject11(), (0, _Theme2.variables)(props).headerSizes.lg[props.size] * (props.headline ? (0, _Theme2.variables)(props).headlineModifier : 1));
}, function (props) {
  return _Theme3.media.xl(_templateObject12(), (0, _Theme2.variables)(props).headerSizes.xl[props.size] * (props.headline ? (0, _Theme2.variables)(props).headlineModifier : 1));
});
var letterSpacing = (0, _styledComponents.css)(_templateObject13(), function (props) {
  return props.headline ? props.size === 1 ? (0, _Theme2.variables)(props).letterSpacing.headline[1] : props.size === 2 ? (0, _Theme2.variables)(props).letterSpacing.headline[2] : props.size === 3 ? (0, _Theme2.variables)(props).letterSpacing.headline[3] : props.size === 4 ? (0, _Theme2.variables)(props).letterSpacing.headline[4] : props.size === 5 ? (0, _Theme2.variables)(props).letterSpacing.headline[5] : (0, _Theme2.variables)(props).letterSpacing.headline[6] : props.size === 1 ? (0, _Theme2.variables)(props).letterSpacing.header[1] : props.size === 2 ? (0, _Theme2.variables)(props).letterSpacing.header[2] : props.size === 3 ? (0, _Theme2.variables)(props).letterSpacing.header[3] : props.size === 4 ? (0, _Theme2.variables)(props).letterSpacing.header[4] : props.size === 5 ? (0, _Theme2.variables)(props).letterSpacing.header[5] : (0, _Theme2.variables)(props).letterSpacing.header[6];
});
var letterSpacing2 = (0, _styledComponents.css)(_templateObject14(), function (props) {
  return props.headline ? (0, _Theme2.variables)(props).letterSpacing.headline[1] : (0, _Theme2.variables)(props).letterSpacing.header[1];
});
var lineHeight = (0, _styledComponents.css)(_templateObject15(), function (props) {
  return props.size === 1 ? (0, _Theme2.variables)(props).lineHeight[1] : props.size === 2 ? (0, _Theme2.variables)(props).lineHeight[2] : props.size === 3 ? (0, _Theme2.variables)(props).lineHeight[3] : props.size === 4 ? (0, _Theme2.variables)(props).lineHeight[4] : props.size === 5 ? (0, _Theme2.variables)(props).lineHeight[5] : (0, _Theme2.variables)(props).lineHeight[6];
});
var decoration = (0, _styledComponents.css)(_templateObject16(), function (props) {
  return props.italic && (0, _styledComponents.css)(_templateObject17());
});

var H1 = _styledComponents.default.h1(_templateObject18(), generic, sizing, font, decoration, letterSpacing, lineHeight, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return (0, _Theme4.display)(props);
}, _styledSystem.space);

exports.H1 = H1;

var H2 = _styledComponents.default.h2(_templateObject19(), generic, sizing, font, decoration, letterSpacing, lineHeight, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return (0, _Theme4.display)(props);
}, _styledSystem.space);

exports.H2 = H2;

var H3 = _styledComponents.default.h3(_templateObject20(), generic, sizing, font, decoration, letterSpacing, lineHeight, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return (0, _Theme4.display)(props);
}, _styledSystem.space);

exports.H3 = H3;

var H4 = _styledComponents.default.h4(_templateObject21(), generic, sizing, font, decoration, letterSpacing, lineHeight, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return (0, _Theme4.display)(props);
}, _styledSystem.space);

exports.H4 = H4;

var H5 = _styledComponents.default.h5(_templateObject22(), generic, sizing, font, decoration, letterSpacing, lineHeight, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return (0, _Theme4.display)(props);
}, _styledSystem.space);

exports.H5 = H5;

var H6 = _styledComponents.default.h6(_templateObject23(), generic, sizing, font, decoration, letterSpacing, lineHeight, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return (0, _Theme4.display)(props);
}, _styledSystem.space);

exports.H6 = H6;

var P = _styledComponents.default.p(_templateObject24(), generic, sizing, font, decoration, letterSpacing, lineHeight, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return (0, _Theme4.display)(props);
}, _styledSystem.space);

exports.P = P;

var Div = _styledComponents.default.div(_templateObject25(), generic, sizing, font, decoration, letterSpacing, lineHeight, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return (0, _Theme4.display)(props);
}, _styledSystem.space);

exports.Div = Div;

var Span = _styledComponents.default.span(_templateObject26(), generic, sizing, font, decoration, letterSpacing, lineHeight, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return (0, _Theme4.display)(props);
}, _styledSystem.space);

exports.Span = Span;

var Label = _styledComponents.default.label(_templateObject27(), generic, sizing, font, decoration, letterSpacing, lineHeight, function (props) {
  return (0, _Theme.spacing)(props);
}, function (props) {
  return (0, _Theme4.display)(props);
}, _styledSystem.space);

exports.Label = Label;